import { get as val } from 'object-path'
import * as immu from 'object-path-immutable'
import langs from './language.json'
import * as risk from './provider.risk.js'

// Names export
export function provider( xeon ) {

  const rulesById = Object.values( xeon.rules ).reduce( ( acc, cur ) => {
    if ( cur.group == "adverse" && cur.param.some( l => l.includes( "extra qtc" ) ) ) {
      acc[ cur.id ] = cur
    }
    return acc
  }, {} )

  const kineticRules = Object.values( xeon.rules ).reduce( ( acc, cur ) => {
    if ( cur.group == "kinetic" ) {
      acc[ cur.drug ] = cur
    }
    return acc
  }, {} )

  return {

    // Score between 0 -100
    score: function ( scale = 5 ) {
      const notNegativ = Math.max( 0, this.scoring().value - 1 )
      // Maximal 60%
      return Math.min( 60, parseInt( notNegativ * scale ) )
    },

    // ----------------------------------------------
    // Give qtc a score between 1 - 10
    // based on dimension 0 - 20
    // ----------------------------------------------
    /*
    possible ekg qtc 6
    possible age years 3
    possible gender bio 3
    possible gewicht bmi 1
    possible heartdisease hypertension 3
    possible heartdisease cardiomyopathy 0
    possible heartdisease ejectionfraction 0
    possible heartdisease arrhythmia 3
    possible metabolic diabetes 0.5
    possible metabolic thyroid 3
    possible neurologic general 0.5
    possible liver stage 1
    possible renal gfr 0.5
    real elektrolyt kalium 6
    real elektrolyt calcium 0
    unknown entzündung crp 1
    */
    // real: 6+3.5 from medication = 9.5 unknown:1 possible: 24.5
    scoring: function () {

      // No substance
      if ( !Object.keys( xeon.drugs ).length ) {
        return { value: null }
      }

      // Rispoints always 0 even for no drugs
      // riskPointsUnknown only available if all questions answered
      const { riskPoints, riskPointsUnknown, riskPointsPossible } = this.computeRisk()

      // Relevant drugs with range
      const scale = 0.5
      const value = ( riskPoints ) * scale + 1
      const range = ( riskPointsUnknown + riskPointsPossible ) * scale

      // Not relevant drugs
      const condition1 = this.drugsWith( "possible" ).length >= 2
      const condition2 = this.drugsWith( "conditional" ).length >= 1 && this.drugsWith( "qtc" ).length >= 2
      const condition3 = this.drugsWith( "known" ).length >= 1
      if ( !condition1 && !condition2 && !condition3 ) {
        return { value: 1 }
      }

      // console.log( "Risk", riskPoints, riskPointsUnknown, riskPointsPossible )
      // console.log( "Points", value, range )

      // Do not penalize if the score is less then 10, but show range
      if ( riskPoints < 10 ) {
        return {
          value: 1,
          range: [ 1, value + range ]
        }
      }

      return {
        value: value,
        range: [ value, value + range ]
      }
    },

    abstract: function ( lang ) {
      return {
        name: langs[ lang ][ "title" ],
        hash: "qtc",
        ...this.scoring()
      }
    },

    // --------------------------------
    // Helper
    // --------------------------------
    drugs: function () {
      return Object.values( xeon.drugs )
    },

    // -------------------------
    // Provide filtered rules
    // -------------------------
    rulesById: function () {
      return rulesById
    },
    rules: function () {
      return Object.values( rulesById )
    },


    // --------------------------------------
    // Filter drugs array for condition
    // e.g. drugsWith( 'conditional' )
    // --------------------------------------
    drugsWith: function ( condition ) {

      // Return array of matched drugs for condition
      return this.drugs().filter( drug => {
        if ( condition == "nonqtc" ) {
          return this.rules().every( rule => rule.drug != drug.id )
        }
        if ( condition == "qtc" ) {
          return this.rules().some( rule => rule.drug == drug.id )
        }
        if ( condition == "possible" ) {
          return this.rules().some( rule => rule.drug == drug.id && rule.param.some( l => {
            return l.includes( "grad:possible" ) && l.includes( "qtc" )
          } ) )
        }
        if ( condition == "known" ) {
          return this.rules().some( rule => rule.drug == drug.id && rule.param.some( l => {
            return l.includes( "grad:known" ) && l.includes( "qtc" )
          } ) )
        }
        if ( condition == "conditional" ) {
          return this.rules().some( rule => rule.drug == drug.id && rule.param.some( l => {
            return l.includes( "grad:conditional" ) && l.includes( "qtc" )
          } ) )
        }
        if ( condition == "nofilter" ) {
          return true
        }
      } )

    },

    drugNamesById: function ( lang ) {
      return this.drugsWith( "qtc" ).reduce( ( acc, cur ) => {
        acc[ cur.id ] = cur.name[ lang ]
        return acc
      }, {} )
    },

    // ---------------------------------------------------------------
    // @return riskPoints (int), risks, riskPointsUnknown (int), risksUnknown  }
    // ---------------------------------------------------------------
    computeRisk: function () {
      return risk.computeRisk( xeon.faqs, this.rules(), kineticRules )
    }

  }

}